module.exports = "/_next/static/images/constructionMob-ca420913f53339c4d300676a11c7124d.png.webp";